var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLikeStandbyPlayer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 14 11.8",
    style: {
      enableBackground: "new 0 0 14 11.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#ff7166;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_2_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Union_1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M13.8,2.5c-0.1-0.2-0.1-0.3-0.2-0.5c0-0.1-0.1-0.2-0.1-0.2c-0.1-0.1-0.2-0.3-0.3-0.4 c-0.1-0.1-0.2-0.2-0.3-0.3C12,0.4,10.9,0,9.9,0c-1,0-2,0.4-2.9,1.1C5.3-0.3,2.9-0.2,1.3,1.2C1.2,1.3,1.1,1.4,1,1.5 C0.3,2.3,0,3.3,0.1,4.3v0c0,0,0,0,0,0.1c0,0,0,0,0,0.1c0,0.1,0,0.2,0.1,0.3c0,0.2,0.1,0.4,0.2,0.5l0.9,1.2v0L7,11.8l5.8-5.4 l0.3-0.3C14,5.1,14.2,3.7,13.8,2.5z M12.1,5.8L7,10.4L1.8,5.7C1.3,5.2,1,4.5,1,3.8C1,3,1.3,2.3,1.9,1.9C2.5,1.3,3.3,1,4.1,1h0 C5,1,5.8,1.3,6.4,1.8L7,2.4l0.7-0.6C8.3,1.3,9,1,9.9,1c0.8,0,1.6,0.3,2.2,0.9C12.7,2.3,13,3,13,3.8C13,4.5,12.7,5.3,12.1,5.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M13.8,2.5c0-0.2-0.1-0.3-0.2-0.5c0-0.1-0.1-0.2-0.1-0.2c-0.1-0.1-0.2-0.3-0.3-0.4c-0.1-0.1-0.2-0.2-0.3-0.3 C12,0.4,10.9,0,9.9,0c-1,0-2,0.4-2.9,1.1C6.2,0.4,5.2,0,4.1,0C3.1,0,2.1,0.5,1.3,1.2C1.2,1.3,1.1,1.4,1,1.4 C0.4,2.1,0.1,3,0.1,3.9c0,0.1,0,0.2,0,0.4v0c0,0,0,0,0,0.1c0,0,0,0,0,0.1c0,0.1,0,0.2,0.1,0.3c0,0.2,0.1,0.4,0.2,0.5l0.9,1.2 L7,11.8l5.8-5.4c0.1-0.1,0.2-0.2,0.3-0.3C14,5.1,14.2,3.7,13.8,2.5z M1.8,5.7C1.3,5.2,1,4.5,1,3.8C1,3,1.3,2.3,1.9,1.9 C2.5,1.3,3.3,1,4.1,1h0C5,1,5.8,1.3,6.4,1.8L7,2.4l0.7-0.6C8.3,1.3,9,1,9.9,1c0.8,0,1.6,0.3,2.2,0.9C12.7,2.3,13,3,13,3.8 c0,0.8-0.3,1.5-0.9,2L7,10.4L1.8,5.7z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikeStandbyPlayer);
export default __webpack_public_path__ + "static/media/like_standby_player.06cc3d4274d788935721bc4fdd979f2d.svg";
export { ForwardRef as ReactComponent };